import React, { useEffect, useState } from "react";
import "./Countdown.css";
type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  finished: boolean;
};
const targetDate: any = new Date("2025-10-10T00:00:00");

export const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(getTimeLeft());

  useEffect(() => {
     if (timeLeft.finished) return;
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft.finished]);

 return (
    <div className="countdown-wrapper">
      <div className="countdown-date">
        <span className="countdown-number">10</span> DE OCTUBRE{" "}
        <span className="countdown-number">2025</span>
      </div>

     
        <div className="countdown-group">
          <div className="countdown-column">
            <span className="value">{pad(timeLeft.days)}</span>
            <span className="label">DÍAS</span>
          </div>
          <div className="separator">:</div>

          <div className="countdown-column">
            <span className="value">{pad(timeLeft.hours)}</span>
            <span className="label">
              <span className="label-full">HORAS</span>
              <span className="label-short">HRS</span>
            </span>
          </div>
          <div className="separator">:</div>

          <div className="countdown-column">
            <span className="value">{pad(timeLeft.minutes)}</span>
            <span className="label">
              <span className="label-full">MINUTOS</span>
              <span className="label-short">MIN</span>
            </span>
          </div>
          <div className="separator">:</div>

          <div className="countdown-column">
            <span className="value">{pad(timeLeft.seconds)}</span>
            <span className="label">
              <span className="label-full">SEGUNDOS</span>
              <span className="label-short">SEG</span>
            </span>
          </div>
        </div>
      
    </div>
  );
};

const  getTimeLeft =(): TimeLeft =>{
  const now = Date.now();
  const diff = new Date(targetDate).getTime() - now;

  const total = Math.max(0, diff); // evita negativos
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / 1000 / 60 / 60) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return { days, hours, minutes, seconds, finished: diff <= 0 };
}

const  pad=(n: number) =>{
  return String(n).padStart(2, "0");
}
